module.exports = __webpack_public_path__ + "media/images/return_cases/shopify-4b20c9da07dbb900a0df3734beb41bee.svg";